export { default } from './TooltipLeadsCustomers'
export type {
  TooltipLeadsCustomersProps,
  FilterType
} from './TooltipLeadsCustomers'
